import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleAmped52AhNMCBluetoothWithCharger = () => {
  console.log('🎯 SimpleAmped52AhNMCBluetoothWithCharger component loading');
  
  const product = findProductById("amped-52ah-nmc-bluetooth-with-charger");
  
  if (!product) {
    console.error('Product not found:', "amped-52ah-nmc-bluetooth-with-charger");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="amped-52ah-nmc-bluetooth-with-charger"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleAmped52AhNMCBluetoothWithCharger; 